import ReservationFlowBookingWidgetContainer from './ReservationFlowBookingWidgetContainer';

export default ReservationFlowBookingWidgetContainer;
